import { lazy, Suspense } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { ChatChartPlaceholder } from "./ChatChartPlaceholder";
import type { ChatChartProps } from "./ChatChart.types";

export { ChatChartPlaceholder };

// Highcharts + its chart generators are ~800KB and were sitting in the eager
// entry chunk purely because Sirius Chat is mounted in the app shell. Chat
// charts only appear when the agent emits one, so pay for them on first use.
const ChatChartRenderer = lazy(() => import("./ChatChartRenderer"));

export function ChatChart(props: ChatChartProps) {
  return (
    <Suspense
      fallback={
        <ChatChartPlaceholder>
          <CircularProgress size={20} color="inherit" />
          Generating chart...
        </ChatChartPlaceholder>
      }
    >
      <ChatChartRenderer {...props} />
    </Suspense>
  );
}
